import { React, useState } from 'react'
import OtpInput from 'react-otp-input';
import logo from '../../Assets/images/logo/SenicLogo.png'
import { Link } from 'react-router-dom'
import { GrHome } from 'react-icons/gr'
import Input from '../../Components/Input/Input'
import { requiredValueValidator, minValueValidator, maxValueValidator, confirmPasswordValidator } from '../../Validator/Rules';
import { useForm } from '../../Hooks/useForm'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';
import Swal from 'sweetalert2'
import Header from '../../Layout/Header/Header';
import Footer from '../../Layout/Footer/Footer';
import NavbarMobile from '../../Components/NavbarMobile/NavbarMobile';
function Register() {
  const [formState, onInputHandler] = useForm({
    userName: {
      value: '',
      isValid: false
    },
    mobile: {
      value: '',
      isValid: false
    },
    password: {
      value: '',
      isValid: false
    },
    confirmpassword: {
      value: '',
      isValid: false
    },
  }, false)
  const [showVerification, setShowVerification] = useState(false);
  const [otp, setOtp] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('09386181632');


  const handleRegisterUser = () => {
    axiosConfig.post('/api/Auth/Register',
      {
        userName: formState.inputs.userName.value,
        phoneNumber: formState.inputs.mobile.value,
        password: formState.inputs.password.value,
        confirmPassword: formState.inputs.confirmpassword.value,
      }).then((res) => {
        Swal.fire({
          icon: 'success',
          title: 'تبریک',
          text: 'حساب کاربری با موفقیت ایجاد شد',
          confirmButtonText: "<Link to='/'> ورود به پنل </Link>"
        })
        axiosConfig
          .post("api/auth/login", {
            userName: formState.inputs.userName.value,
            password:formState.inputs.password.value,
          })
          .then((result) => {
            localStorage.setItem("token", result.data.data.token);
            localStorage.setItem("userId", result.data.data.userId);
            localStorage.setItem("name", result.data.data.name);
            window.location.href = "/";
          })
      }).catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'خطا',
          text: "کاربر با این اطلاعات وجود دارد",
        })
      })
  }

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleSendCode = () => {
    setShowVerification(true);
  };

  const handleOtpChange = (code) => {
    setOtp(code);
  };
  const renderInput = (props) => {
    const { value, onChange, ...rest } = props;
    return (
      <input
        type="number"
        value={value}
        onChange={onChange}
        {...rest}
        style={{ width: '2rem', height: '2rem', margin: '0 0.5rem', direction: 'ltr' }}
      />
    );
  };
  return (
    <>
      {
        showVerification ? (
          <div className='form-component'>
            <div className='form-verify'>
              <h2>تایید کد</h2>
              <p>کد تایید به شماره تلفن {phoneNumber} ارسال شد.</p>
              <OtpInput
                value={otp}
                onChange={handleOtpChange}
                numInputs={6}
                separator={<span>-</span>}
                renderInput={renderInput}
              />
              <button>تایید</button>
            </div>

          </div>
        ) : (
          <>
            <div className='form-component'>
              <div className='form-wrapper'>
                <h1 className='form-title'>ثبت نام</h1>
                <div className='not-registered'>
                  <h2>ثبت نام هستید؟</h2>
                  <button>
                    <Link to='/login'>
                      وارد شوید
                    </Link>
                  </button>
                </div>
                <div className='form-inputs'>
                  <Input element='Input' id='userName' placeholder='نام کاربری   ' className='form-input' type='text' validitation=
                    {
                      [
                        requiredValueValidator(),
                        minValueValidator(4),
                        maxValueValidator(25)
                      ]
                    }
                    onInputHandler={onInputHandler}
                  />
                  {

                  }
                  <Input element='Input' id='mobile' placeholder='شماره موبایل' className='form-input' type='number' validitation=
                    {
                      [
                        requiredValueValidator(),
                        minValueValidator(11),
                        maxValueValidator(20)
                      ]
                    }
                    onInputHandler={onInputHandler}
                  />
                  <Input element='Input' id='password' placeholder='رمز عبور' className='form-input' type='password' validitation=
                    {
                      [
                        requiredValueValidator(),
                        minValueValidator(4),
                        maxValueValidator(20)
                      ]
                    }
                    onInputHandler={onInputHandler}
                  />
                  <Input element='Input' id='confirmpassword' placeholder='تکرار رمز عبور' className='form-input' type='password' validitation=
                    {
                      [
                        confirmPasswordValidator(formState.inputs.password.value)
                      ]
                    }
                    onInputHandler={onInputHandler}
                  />
                </div>
                <button
                  className={`form-btn ${formState.isFormValid ? 'succes' : 'error'}`}
                  disabled={(!formState.isFormValid)}
                  onClick={handleRegisterUser}
                >عضویت</button>
              </div>
            </div>
          </>
        )
      }
    </>

  )
}
export default Register
